export interface SelectOption {
  id?: number | string;
  title: string;
  value: string | number;
  customClass?: string;
  data?: object;
}

export enum ListPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export enum DropdownEvents {
  OPTION_SELECTED = 'optionSelected',
}
